import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

import { ETLCodes } from "./ETLCodes";

(window as any).MISSING_TL_KEYS = {};
(window as any).GetMissingKeysEnum = () => {
  const s = Object.keys((window as any).MISSING_TL_KEYS).join(",\n");
  console.log("," + s);
  return s;
};

export const initTranslator = (baseUrl: string) => {
  i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init(
      {
        lng: "fr",
        fallbackLng: "en",
        ns: ["translation"], // Namespace par défaut explicite
        defaultNS: "translation",
        react: {
          useSuspense: true,
        },
        backend: {
          loadPath: `${baseUrl}/api/translation/?languageCode={{lng}}`,
          // addPath doit être une fonction qui retourne le path personnalisé
          // i18next-http-backend s'attend à recevoir {{lng}} ET {{ns}}, mais notre API n'utilise pas ns dans l'URL
          addPath: (lng: string, ns: string) => {
            console.log("[i18next] addPath called with:", { lng, ns }); // Debug log
            return `${baseUrl}/api/translation/${lng}`;
          },
          parse: (data: string) => {
            const parsed = JSON.parse(data);
            const reduced: object = parsed.reduce((prev, curr) => {
              prev[curr.translationCode] = curr.text;
              return prev;
            }, {});
            return reduced;
          },
          // customHeaders: fonction async qui récupère le JWT token depuis MSAL

          parsePayload: function (namespace, key, fallbackValue) {
            console.log("[i18next] Saving missing key:", {
              namespace,
              key,
              fallbackValue,
            }); // Debug log
            return {
              text: fallbackValue || key,
              translationCode: key,
            };
          },
          // Options CORS: withCredentials à true pour envoyer les cookies de session
          crossDomain: false,
          withCredentials: true,
        },
        keySeparator: false,
        interpolation: {
          escapeValue: false,
        },
        // missingKeyHandler pour tracking local des clés manquantes
        // ET appel manuel au backend pour sauvegarder (car saveMissing ne fonctionne pas automatiquement)
        missingKeyHandler: (lngs, ns, key, fallbackValue) => {
          console.log("[i18next] Missing key detected:", {
            lngs,
            ns,
            key,
            fallbackValue,
          }); // Debug log
          (window as any).MISSING_TL_KEYS[key] = true;

          // Appel manuel à backend.create() car saveMissing ne le fait pas automatiquement dans i18next v21+
          const backend = i18n.services?.backendConnector?.backend;
          if (backend && typeof backend.create === "function") {
            console.log("[i18next] Calling backend.create manually for:", key);
            backend.create(lngs, ns, key, fallbackValue);
          }
        },
        // parseMissingKeyHandler définit ce qui est affiché à l'utilisateur quand une clé est manquante
        parseMissingKeyHandler: (key) => {
          return `${key}_MISSING_TL`;
        },
        saveMissing: true,
        saveMissingTo: "current", // Sauver les clés manquantes uniquement pour la langue courante
        updateMissing: false, // Ne pas mettre à jour les traductions existantes
      },
      (err) => {
        if (err) {
          console.error("[i18next] Initialization error:", err);
        }
      }
    );
};

export const tlCodesArray = Object.keys(ETLCodes)
  .filter((k) => typeof ETLCodes[k as any] === "number")
  .sort();

export { ETLCodes };
